import { render, staticRenderFns } from "./CloseInternalIssue.vue?vue&type=template&id=679bf26e"
import script from "./CloseInternalIssue.vue?vue&type=script&lang=js"
export * from "./CloseInternalIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports